import { Group, Menu } from '@mantine/core';
import type { NotificationRuleOut } from '@repo/api-codegen';
import { SettingsBlock } from '@repo/common/components';
import { Icon, IconButton, Text } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { openDeleteConfirmModal } from '../../../components/ModalManager';

interface NotificationRuleCardProps {
	rule: NotificationRuleOut;
	onEdit: (rule: NotificationRuleOut) => void;
	onDelete: (id: string) => void;
}

export const NotificationRuleCard = observer(
	({ rule, onEdit, onDelete }: NotificationRuleCardProps) => {
		const handleEdit = (e: React.MouseEvent) => {
			e.stopPropagation();
			onEdit(rule);
		};

		const handleDelete = (e: React.MouseEvent) => {
			e.stopPropagation();
			openDeleteConfirmModal({
				title: 'Delete notification rule?',
				description: "You can't undo this action.",
				onConfirm: () => onDelete(rule.id),
			});
		};

		return (
			<SettingsBlock
				title={
					<Group noWrap align="center" spacing="xs">
						<Icon name="bell" />
						<Text weight="semibold">{rule.title}</Text>
					</Group>
				}
				description={
					rule.description ? (
						<Text size="sm" color="text/secondary/default">
							{rule.description}
						</Text>
					) : null
				}
				rightComponent={
					<Menu position="bottom-end">
						<Menu.Target>
							<IconButton
								iconName="dots"
								variant="tertiary"
								tooltip="More actions"
								onClick={(e) => e.stopPropagation()}
							/>
						</Menu.Target>
						<Menu.Dropdown>
							<Menu.Item icon={<Icon name="pencil" />} onClick={handleEdit}>
								Edit
							</Menu.Item>
							<Menu.Item icon={<Icon name="trash" />} onClick={handleDelete}>
								Delete...
							</Menu.Item>
						</Menu.Dropdown>
					</Menu>
				}
			/>
		);
	}
);
